enum PrescriptionAddSegmentationType {
    HIGH_ADD = 'high_add',
    MID_ADD = 'mid_add',
    LOW_ADD = 'low_add',
}

export default PrescriptionAddSegmentationType;